// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"az_Im","topHrTag":"az_Jm","bottomHrTag":"az_Km","linksAndCookieBtn":"az_Lm"};